import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { initials } from './memoryUtils';
import './SiteLayout.css';

export const ProfileAvatar = ({ profile }) => {
  if (!profile.avatar) return (
    <span className="profile-avatar profile-initials" aria-label={profile.name}>
      {initials(profile.name)}
    </span>
  );
  const crop = profile.settings?.avatarCrop || {};
  const clamp = (value, fallback, min, max) => Number.isFinite(value) ? Math.max(min, Math.min(max, value)) : fallback;
  const position = `${clamp(crop.x, 50, 0, 100)}% ${clamp(crop.y, 50, 0, 100)}%`;
  return (
    <span className="profile-avatar">
      <img src={profile.avatar} alt={profile.name} style={{ transform: `scale(${clamp(crop.zoom, 1, 1, 4)})`, transformOrigin: position }} />
    </span>
  );
};

export const SiteHeader = ({ onAdd, profileNav = false, hasStory = false }) => (
  <header className="site-header">
    <div className="site-shell site-header-inner">
      <Link className="site-brand" to="/">
        <img src="/logo_vzpominkovnik.png" alt="" />
        <strong>Vzpomínkovník</strong>
      </Link>
      {profileNav && (
        <nav aria-label="Profil">
          <a href="#vzpominky">Vzpomínky</a>
          {hasStory && <a href="#pribeh">O životě</a>}
          <a href="#lide">Přispěli</a>
        </nav>
      )}
      {onAdd && (
        <button className="site-button" title="Přidat vzpomínku" aria-label="Přidat vzpomínku" onClick={onAdd}>
          <Plus size={18} />
          <span>Přidat vzpomínku</span>
        </button>
      )}
    </div>
  </header>
);

export const SiteFooter = ({ children }) => (
  <footer className="site-footer">
    <div className="site-shell">
      <Link to="/">Vzpomínkovník</Link>
      {children}
    </div>
  </footer>
);
